import type { CSSProperties } from 'react';
import { FORM_COLOR } from '@/pages/Seminar/components/form/formStyles';

// 채용 카드 공통: 사용자 지정 소형 칩. 윗줄 간격은 각 카드의 gap에 2px을 더한다.
export const RECRUITMENT_CHIP_HEIGHT = 12;
export const recruitmentChipStyle: CSSProperties = {
    fontSize: 10,
    lineHeight: '12px',
    padding: '0 3px',
    borderRadius: 3,
    backgroundColor: FORM_COLOR.lineSoft,
    color: FORM_COLOR.muted,
};
export const recruitmentChipCountStyle: CSSProperties = {
    fontSize: 10,
    lineHeight: '12px',
    color: FORM_COLOR.muted,
};
export const recruitmentChipRowStyle: CSSProperties = {
    marginTop: 2,
    flexShrink: 0,
};
/** 당일 지급 칩 — 눈에 띄게(청록 옅은 바탕·진한 청록 글자, 토큰 색만). 크기·여백은 기본 칩과 같아 줄 높이가 그대로다 */
export const recruitmentChipAccentStyle: CSSProperties = {
    backgroundColor: FORM_COLOR.primarySoft,
    color: FORM_COLOR.primaryDeep,
    fontWeight: 700,
};
